import Vue from "vue";
import axios from "axios";
import TokenService from "../service/token";
import { Message, Loading } from "element-ui";
import CacheService from "@/service/catch";

const isEnv = process.env.NODE_ENV === "development";

let config = {
  headers: {},
};

let host = window.location.host;
let api;
if (isEnv) {
  api = host;
} else {
  let apiList = host.split(".");
  apiList[0] = "api";
  api = apiList.join(".") + "/api"; // "//api.maidiyun.cn/api"
}

const request = axios.create(config);
/*是否有请求正在刷新token*/
let isRefreshing = false;
let refreshSubscribers = [];

export async function getProxy() {
    const { data } = await axios.get(`//${api}/OpencloudManager/SetConfiguration/SetConfigurationList`);
    data.data.forEach((d) => {
      config[d.keyName] = d.keyValue; // baseURL fileBaseUrl ssoUrl ossUrl;
      Vue.prototype["$" + d.keyName] = d.keyValue; // $baseURL $fileBaseUrl $ssoUrl $ossUrl;
    });

  let loading = null;

  let token = TokenService.get();
  if (token) {
    request.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
  }
  request.interceptors.request.use(
    (data) => {
      if (!isEnv) data.baseURL = config.baseURL;
      loading = Loading.service({
        text: "Loading",
        background: "transparent",
      });
      return data;
    },
    (err) => Promise.reject(err)
  );

  request.interceptors.response.use(
    (response) => {
      loading && loading.close();
      if (response.data.code === 200) {
        return response.data.data;
      } else {
        Message.error(response.data.errormsg);
        return Promise.reject(response.data.errormsg);
      }
    },
    (error) => {
      const response = error.response;
      loading && loading.close();
      // Message.error('请求错误')
      // return Promise.reject(error);
      if (response.status === 401) {
        const user = TokenService.get();
        if (!isRefreshing) {
          isRefreshing = true;
          request.get(`/Crm/User/RefreshToken?refreshToken=${encodeURIComponent(user.refreshToken)}`).then(
            (res) => {
              isRefreshing = false;
              if (res.accessToken) {
                TokenService.set({ ...user, ...res });
                request.defaults.headers.common.Authorization = `Bearer ${res.accessToken}`;
                refreshSubscribers.forEach((cb) => cb(res.accessToken));
                refreshSubscribers = [];
              }
            },
            () => {
              isRefreshing = false;
              CacheService.clear();
            }
          );
        }
        let retry = new Promise((resolve, reject) => {
          refreshSubscribers.push((token) => {
            response.config.headers.Authorization = "Bearer " + token;
            request(response.config).then((res) => {
              resolve(res);
            });
          });
        });
        return retry;
      } else if (response.status === 419) {
        Message.error("该账号已在其他终端登录，请重新登录！");
      } else if (response.status === 403) {
        Message.error("暂无权限，请联系管理员授权");
        return Promise.reject(error);
      } else {
        Message.error("请求失败，请重试");
        return Promise.reject(error);
      }
    }
  );

  Plugin.install = function (Vue, options) {
    Vue.axios = request;
    window.axios = request;
    Object.defineProperties(Vue.prototype, {
      axios: {
        get() {
          return request;
        },
      },
      $axios: {
        get() {
          return request;
        },
      },
    });
  };
  Vue.use(Plugin);
}

export default request;
